import { FieldOrigin } from 'features/libra/ontology/ontologyFieldTypes'
import { ZoneParams } from 'features/libra/stepComponents/zoneAnalysis/zoneAnalysisApi'

function isTabPrefillNew(
  previousZone: ZoneParams | undefined,
  nextZone: ZoneParams
): boolean {
  return Object.entries(nextZone.ai_prefill ?? {}).some(
    ([tab, meta]) =>
      meta.generated_at !== previousZone?.ai_prefill?.[tab]?.generated_at
  )
}

/**
 * Origin of one mutation of the reviewed zone list. The AI is the last writer
 * only when the mutation applied a tab pre-fill (a new `generated_at`); any
 * other change, including a manual edit of a pre-filled zone, makes a person
 * the last writer (`undefined`, recorded as `human` at save). The whole list is
 * one field, so origin is per list, not per zone property.
 */
export function zoneMutationOrigin(
  previousZones: ReadonlyArray<ZoneParams>,
  nextZones: ReadonlyArray<ZoneParams>
): FieldOrigin | undefined {
  const byId = new Map(previousZones.map((zone) => [zone.id, zone]))
  return nextZones.some((zone) => isTabPrefillNew(byId.get(zone.id), zone))
    ? 'llm'
    : undefined
}
